export enum ParticipantSectionDataHooks {
  ROOT = 'participant-section',
  HEADER = 'participant-section-header',
  TITLE = 'participant-section-title',
  TOGGLE = 'participant-section-toggle',
  REMOVE = 'participant-section-remove',
  CHEVRON = 'participant-section-chevron',
  BODY = 'participant-section-body',
}
